import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Luggage, Navigation, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { enlaceMapa, recargarPlanes } from "@/lib/ocio";
import { textoEmbarque } from "@/components/ocio/Embarque";

const filas = (planes) => planes.flatMap((p) => {
  if (p.tipo === "viaje") return [{ p, hora: p.hora, txt: p.nombre, sub: textoEmbarque(p), mapa: true },
    ...(p.hora_llegada ? [{ p, hora: p.hora_llegada, txt: String(p.nombre).includes("→") ? `Llegada a ${String(p.nombre).split("→")[1].replace(/\(.*?\)/g, "").trim()}` : "Llegada", sub: "", mapa: false, k: "llegada" }] : [])];
  return [{ p, hora: p.hora, txt: p.nombre, pre: p.tipo === "hotel" && p.hora ? "check-in " : "", mapa: true }];
}).sort((x, y) => (x.hora || "99:99").localeCompare(y.hora || "99:99"));

// Itinerario del día para planes que el usuario confirmó como un mismo viaje.
export const ResumenViaje = ({ planes, children, testid = "ocio-resumen-viaje" }) => {
  const navigate = useNavigate();
  const separar = async (p) => {
    try { await api.delete(`/ocio/planes/${p.id}/viaje`); await recargarPlanes(); toast.success("Plan separado del viaje"); }
    catch { toast.error("No se pudo separar."); }
  };
  return (
    <section className="bg-[#E8F0EC] border border-[#C9D8CF] rounded-2xl p-4 space-y-3" data-testid={testid}>
      <h2 className="font-heading text-xl font-bold text-[#1C2421] flex items-center gap-2"><Luggage size={22} className="text-[#3A6B56]" /> Tu viaje de hoy</h2>
      <ol className="space-y-2">
        {filas(planes).map((f) => (
          <li key={`${f.p.id}-${f.k || "p"}`} className="bg-white rounded-xl p-3 flex items-start gap-3" data-testid={`ocio-viaje-fila-${f.p.id}${f.k ? `-${f.k}` : ""}`}>
            <span className="shrink-0 w-14 font-heading font-bold text-lg text-[#3A6B56]">{f.hora || "—"}</span>
            <span className="flex-1 min-w-0">
              <span className="block font-semibold text-base text-[#1C2421] break-words">{f.txt}{f.pre ? ` · ${f.pre}${f.hora}` : ""}</span>
              {f.sub && <span className="block text-sm font-semibold text-[#1C2421]">{f.sub}</span>}
              <span className="flex flex-wrap gap-2 mt-2">
                {!f.k && <button data-testid={`ocio-viaje-abrir-${f.p.id}`} onClick={() => navigate(`/ocio?plan=${f.p.id}`)} className="inline-flex items-center gap-1 min-h-[40px] px-3 rounded-lg bg-[#3A6B56] text-white text-sm font-semibold">Abrir <ChevronRight size={16} /></button>}
                {f.mapa && enlaceMapa(f.p) && <a data-testid={`ocio-viaje-mapa-${f.p.id}`} href={enlaceMapa(f.p)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 min-h-[40px] px-3 rounded-lg border-2 border-[#3A6B56] text-[#3A6B56] text-sm font-semibold"><Navigation size={15} /> Cómo llegar</a>}
                {!f.k && children && <button data-testid={`ocio-viaje-separar-${f.p.id}`} onClick={() => separar(f.p)} className="min-h-[40px] px-2 text-sm text-[#4A5550] underline underline-offset-4">No es de este viaje</button>}
              </span>
            </span>
          </li>
        ))}
      </ol>
      {children}
    </section>
  );
};
